import React from 'react'
import Link from 'next/link'
import BlogImage from './Image'
import styles from '../../styles/components/ResourceCard.module.css'

const ResourceCard = ({ article }) => {
  return (
    <article className={`bg-light overflow-hidden br-3 h-100 ${styles.card}`}>
      <Link
        href={`/resources/${article.attributes.slug}`}
        legacyBehavior
      >
        <div className='d-flex flex-column h-100'>
          <div
            className='br-3 overflow-hidden'
            style={{ maxHeight: '300px' }}
          >
            <BlogImage image={article.attributes.image} />
          </div>
          <div
            className="p-4 d-flex flex-column gap-3"
          >
            <h2 className="fw-semibold">
              {article.attributes.title}
            </h2>
            <div className='fs-5'>
              {article.attributes.description}
            </div>
          </div>
          <div
            className='p-4 fs-lg-5 border-top border-1 bg-dark bg-opacity-25'
            style={{ marginTop: 'auto' }}
          >
            Read more <span className={`fs-5 ${styles.finger}`}>👉</span>
          </div>
        </div>
      </Link>
    </article>
  )
}

export default ResourceCard
